var isMobileScreen = false; //initiate as false

function isMobile() {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4)
      )
    ) {
      isMobileScreen = true;
      return isMobileScreen;
    }
}

(function ($) {
    var $ = (jQuery = $);

    var cc = {
     sections: [],
    };

    theme.Sections = new (function () {
        var _ = this;
        
        _._instances = [];
        _._deferredSectionTargets = [];
        _._sections = [];
        _._deferredLoadViewportExcess = 300; // load defferred sections within this many px of viewport
        
        _._deferredWatcherRunning = false;
        
        _.init = function () {
            $(document)
            .on("shopify:section:load", function (e) {
                // load a new section
                var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
        
                if (target) {
                _.sectionLoad(target);
                }
            })
            .on("shopify:section:unload", function (e) {
                // unload existing section
                var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
        
                if (target) {
                _.sectionUnload(target);
                }
            });
            $(window).on(
            "throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader",
            _._processDeferredSections
            );
            _._deferredWatcherRunning = true;
        }; // register a type of section
        
        _.register = function (type, section, options) {
            _._sections.push({
            type: type,
            section: section,
            afterSectionLoadCallback: options ? options.afterLoad : null,
            afterSectionUnloadCallback: options ? options.afterUnload : null,
            }); // load now
        
            $('[data-section-type="' + type + '"]').each(function () {
            if (
                Shopify.designMode ||
                (options && options.deferredLoad === false) ||
                !_._deferredWatcherRunning
            ) {
                _.sectionLoad(this);
            } else {
                _.sectionDeferredLoad(this, options);
            }
            });
        }; // prepare a section to load later
        
        _.sectionDeferredLoad = function (target, options) {
            _._deferredSectionTargets.push({
            target: target,
            deferredLoadViewportExcess:
                options && options.deferredLoadViewportExcess
                ? options.deferredLoadViewportExcess
                : _._deferredLoadViewportExcess,
            });
        
            _._processDeferredSections(true);
        }; // load deferred sections if in/near viewport
        
        _._processDeferredSections = function (firstRunCheck) {
            if (_._deferredSectionTargets.length) {
            var viewportTop = $(window).scrollTop(),
                viewportBottom = viewportTop + $(window).height(),
                loopStart =
                firstRunCheck === true ? _._deferredSectionTargets.length - 1 : 0;
        
            for (var i = loopStart; i < _._deferredSectionTargets.length; i++) {
                var target = _._deferredSectionTargets[i].target,
                viewportExcess =
                    _._deferredSectionTargets[i].deferredLoadViewportExcess,
                sectionTop = $(target).offset().top - viewportExcess,
                doLoad = sectionTop > viewportTop && sectionTop < viewportBottom;
        
                if (!doLoad) {
                var sectionBottom =
                    sectionTop + $(target).outerHeight() + viewportExcess * 2;
                doLoad =
                    sectionBottom > viewportTop && sectionBottom < viewportBottom;
                }
        
                if (
                doLoad ||
                (sectionTop < viewportTop && sectionBottom > viewportBottom)
                ) {
                // in viewport, load
                _.sectionLoad(target); // remove from deferred queue and resume checks
        
                _._deferredSectionTargets.splice(i, 1);
        
                i--;
                }
            }
            } // remove event if no more deferred targets left, if not on first run
        
            if (firstRunCheck !== true && _._deferredSectionTargets.length === 0) {
            _._deferredWatcherRunning = false;
            $(window).off(".themeSectionDeferredLoader");
            }
        }; // load in a section
        
        _.sectionLoad = function (target) {
            var target = target,
            sectionObj = _._sectionForTarget(target),
            section = false;
        
            if (sectionObj.section) {
            section = sectionObj.section;
            } else {
            section = sectionObj;
            }
        
            if (section !== false) {
            var instance = {
                target: target,
                section: section,
                $shopifySectionContainer: $(target).closest(".shopify-section"),
                thisContext: {
                functions: section.functions,
                },
            };
        
            _._instances.push(instance); //Initialise any components
        
            if ($(target).data("components")) {
                //Init each component
                var components = $(target).data("components").split(",");
                components.forEach(function (component) {
                $(document).trigger("cc:component:load", [component, target]);
                });
            }
        
            _._callWith(section, "onSectionLoad", target, instance.thisContext);
        
            _._callWith(
                section,
                "afterSectionLoadCallback",
                target,
                instance.thisContext
            ); // attach additional UI events if defined
        
            if (section.onSectionSelect) {
                instance.$shopifySectionContainer.on(
                "shopify:section:select",
                function (e) {
                    _._callWith(
                    section,
                    "onSectionSelect",
                    e.target,
                    instance.thisContext
                    );
                }
                );
            }
        
            if (section.onSectionDeselect) {
                instance.$shopifySectionContainer.on(
                "shopify:section:deselect",
                function (e) {
                    _._callWith(
                    section,
                    "onSectionDeselect",
                    e.target,
                    instance.thisContext
                    );
                }
                );
            }
        
            if (section.onBlockSelect) {
                $(target).on("shopify:block:select", function (e) {
                _._callWith(
                    section,
                    "onBlockSelect",
                    e.target,
                    instance.thisContext
                );
                });
            }
        
            if (section.onBlockDeselect) {
                $(target).on("shopify:block:deselect", function (e) {
                _._callWith(
                    section,
                    "onBlockDeselect",
                    e.target,
                    instance.thisContext
                );
                });
            }
            }
        }; // unload a section
        
        _.sectionUnload = function (target) {
            var sectionObj = _._sectionForTarget(target);
        
            var instanceIndex = -1;
        
            for (var i = 0; i < _._instances.length; i++) {
            if (_._instances[i].target == target) {
                instanceIndex = i;
            }
            }
        
            if (instanceIndex > -1) {
            var instance = _._instances[instanceIndex]; // remove events and call unload, if loaded
        
            $(target).off("shopify:block:select shopify:block:deselect");
            instance.$shopifySectionContainer.off(
                "shopify:section:select shopify:section:deselect"
            );
        
            _._callWith(
                instance.section,
                "onSectionUnload",
                target,
                instance.thisContext
            );
        
            _._callWith(
                sectionObj,
                "afterSectionUnloadCallback",
                target,
                instance.thisContext
            );
        
            _._instances.splice(instanceIndex); //Destroy any components
        
            if ($(target).data("components")) {
                //Init each component
                var components = $(target).data("components").split(",");
                components.forEach(function (component) {
                $(document).trigger("cc:component:unload", [component, target]);
                });
            }
            } else {
            // check if it was a deferred section
            for (var i = 0; i < _._deferredSectionTargets.length; i++) {
                if (_._deferredSectionTargets[i].target == target) {
                _._deferredSectionTargets[i].splice(i, 1);
        
                break;
                }
            }
            }
        }; // helpers
        
        _._callWith = function (object, method, param, thisContext) {
            if (typeof object[method] === "function") {
            if (thisContext) {
                object[method].bind(thisContext)(param);
            } else {
                object[method](param);
            }
            }
        };
        
        _._themeSectionTargetFromShopifySectionTarget = function (target) {
            var $target = $("[data-section-type]:first", target);
        
            if ($target.length > 0) {
            return $target[0];
            } else {
            return false;
            }
        };
        
        _._sectionForTarget = function (target) {
            var type = $(target).attr("data-section-type");
        
            for (var i = 0; i < _._sections.length; i++) {
            if (_._sections[i].type == type) {
                return _._sections[i];
            }
            }
        
            return false;
        };
        
        _._sectionAlreadyRegistered = function (type) {
            for (var i = 0; i < _._sections.length; i++) {
            if (_._sections[i].type == type) {
                return true;
            }
            }
        
            return false;
        };
    })(); // Loading third party scripts

    theme.scriptsLoaded = {};

    theme.loadScriptOnce = function (src, callback, beforeRun, sync) {
      if (typeof theme.scriptsLoaded[src] === "undefined") {
        theme.scriptsLoaded[src] = [];
        var tag = document.createElement("script");
        tag.src = src;
  
        if (sync || beforeRun) {
          tag.async = false;
        }
  
        if (beforeRun) {
          beforeRun();
        }
  
        if (typeof callback === "function") {
          theme.scriptsLoaded[src].push(callback);
  
          if (tag.readyState) {
            // IE, incl. IE9
            tag.onreadystatechange = function () {
              if (tag.readyState == "loaded" || tag.readyState == "complete") {
                tag.onreadystatechange = null;
  
                for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
                  theme.scriptsLoaded[this][i]();
                }
  
                theme.scriptsLoaded[this] = true;
              }
            }.bind(src);
          } else {
            tag.onload = function () {
              // Other browsers
              for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
                theme.scriptsLoaded[this][i]();
              }
  
              theme.scriptsLoaded[this] = true;
            }.bind(src);
          }
        }
  
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        return true;
      } else if (
        _typeof(theme.scriptsLoaded[src]) === "object" &&
        typeof callback === "function"
      ) {
        theme.scriptsLoaded[src].push(callback);
      } else {
        if (typeof callback === "function") {
          callback();
        }
  
        return false;
      }
    };
    
    theme.VideoManager = new (function () {
        var _ = this; // Youtube
    
        _.youtubeVars = {
          incrementor: 0,
          apiReady: false,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="youtube"]:not(.video--init)',
        };
    
        _.youtubeApiReady = function () {
          _.youtubeVars.apiReady = true;
    
          _._loadYoutubeVideos();
        };
    
        _._loadYoutubeVideos = function (container) {
          if ($(_.youtubeVars.toProcessSelector, container).length) {
            if (_.youtubeVars.apiReady) {
              // play those videos
              $(_.youtubeVars.toProcessSelector, container).each(function () {
                // Don't init videos on mobile
                if (
                  !(
                    $(this).hasClass("video-container--background") &&
                    $(window).outerWidth() < 768 && !($(this).find('div.video-container__video.video-container__video-show').length !== 0)
                  )
                ) {
                  $(this).addClass("video--init");
                  _.youtubeVars.incrementor++;
                  var containerId = "theme-yt-video-" + _.youtubeVars.incrementor;
                  $(this).data("video-container-id", containerId);
                  var videoElement = $(
                    '<div class="video-container__video-element">'
                  )
                    .attr("id", containerId)
                    .appendTo($(".video-container__video", this));
                  var autoplay = $(this).data("video-autoplay");
                  var player = new YT.Player(containerId, {
                    height: "360",
                    width: "640",
                    videoId: $(this).data("video-id"),
                    playerVars: {
                      iv_load_policy: 3,
                      modestbranding: 1,
                      autoplay: autoplay ? 1 : 0,
                      loop: $(this).data("video-loop") ? 1 : 0,
                      playlist: $(this).data("video-id"),
                      rel: 0,
                      showinfo: 0,
                    },
                    events: {
                      onReady: _._onYoutubePlayerReady.bind({
                        autoplay: autoplay,
                        $container: $(this),
                      }),
                      onStateChange: _._onYoutubePlayerStateChange.bind(this),
                    },
                  });
                  _.youtubeVars.videoData[containerId] = {
                    id: containerId,
                    container: this,
                    videoElement: videoElement,
                    player: player,
                  };
                } else {
                  $(this).find(".video-container__video").hide();
                }
              });
            } else {
              // load api
              theme.loadScriptOnce("https://www.youtube.com/iframe_api");
            }
          }
        };
    
        _._onYoutubePlayerReady = function (event) {
          event.target.setPlaybackQuality("hd1080");
    
          if (this.autoplay) {
            event.target.mute();
            event.target.playVideo();
          }
    
          _._initBackgroundVideo(this.$container);
        };
    
        _._onYoutubePlayerStateChange = function (event) {
          if (event.data == YT.PlayerState.PLAYING) {
            $(this).addClass("video--play-started");
          }
        };
    
        _._unloadYoutubeVideos = function (container) {
          for (var dataKey in _.youtubeVars.videoData) {
            var data = _.youtubeVars.videoData[dataKey];
    
            if ($(container).find(data.container).length) {
              data.player.destroy();
              delete _.youtubeVars.videoData[dataKey];
              return;
            }
          }
        }; // Vimeo
    
        _.vimeoVars = {
          incrementor: 0,
          apiReady: false,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="vimeo"]:not(.video--init)',
        };
    
        _.vimeoApiReady = function () {
          _.vimeoVars.apiReady = true;
    
          _._loadVimeoVideos();
        };
    
        _._loadVimeoVideos = function (container) {
          if ($(_.vimeoVars.toProcessSelector, container).length) {
            if (_.vimeoVars.apiReady) {
              // play those videos
              $(_.vimeoVars.toProcessSelector, container).each(function () {
                // Don't init videos on mobile
                if (
                  !(
                    $(this).hasClass("video-container--background") &&
                    $(window).outerWidth() < 768 &&
                    ($(this).find('div.video-container__video.video-container__video-show').length === 0)
                  )
                ) {
                  $(this).find(".video-container__video").css('display', 'block'); // it displays back the vimeo when switching from mobile to desktop 
                  $(this).addClass("video--init");
                  _.vimeoVars.incrementor++;
                  var $this = $(this);
                  _._initBackgroundVideo($this); // moved this outside ready() so that the css properties are applied all the time
                  var containerId = "theme-vi-video-" + _.vimeoVars.incrementor;
                  $(this).data("video-container-id", containerId);
                  var videoElement = $(
                    '<div class="video-container__video-element">'
                  )
                    .attr("id", containerId)
                    .appendTo($(".video-container__video", this));
                  var autoplay = $(this).data("video-autoplay");
                  var player = new Vimeo.Player(containerId, {
                    url: $(this).data("video-url"),
                    width: 640,
                    loop: $(this).data("video-autoplay"),
                    autoplay: autoplay,
                    autopause: false, // pause this video automatically when another one plays
                    controls: false, // play bar and UI will be hidden
                    muted: true,
                  });
                  player.on(
                    "playing",
                    function () {
                      $(this).addClass("video--play-started");
                    }.bind(this)
                  );
                  player.ready().then(function () {
                    if (autoplay) {
                      player.setVolume(0);
                      player.play();
                    }
                    if (
                      player.element &&
                      player.element.width &&
                      player.element.height
                    ) {
                      var ratio =
                        parseInt(player.element.height) /
                        parseInt(player.element.width);
                      $this
                        .find(".video-container__video")
                        .css("padding-bottom", ratio * 100 + "%");
                    }
                  });
    
                  _.vimeoVars.videoData[containerId] = {
                    id: containerId,
                    container: this,
                    videoElement: videoElement,
                    player: player,
                    autoPlay: autoplay,
                  };
                } else {
                  $(this).find(".video-container__video").hide();
                }
              });
            } else {
              // load api
    
              if (window.define) {
                // workaround for third parties using RequireJS
                theme.loadScriptOnce(
                  "https://player.vimeo.com/api/player.js",
                  function () {
                    _.vimeoVars.apiReady = true;
    
                    _._loadVimeoVideos();
    
                    window.define = window.tempDefine;
                  },
                  function () {
                    window.tempDefine = window.define;
                    window.define = null;
                  }
                );
              } else {
                theme.loadScriptOnce(
                  "https://player.vimeo.com/api/player.js",
                  function () {
                    _.vimeoVars.apiReady = true;
    
                    _._loadVimeoVideos();
                  }
                );
              }
            }
          }
        };
    
        _._unloadVimeoVideos = function (container) {
          for (var dataKey in _.vimeoVars.videoData) {
            var data = _.vimeoVars.videoData[dataKey];
    
            if ($(container).find(data.container).length) {
              data.player.unload();
              delete _.vimeoVars.videoData[dataKey];
              return;
            }
          }
        }; // Mp4
    
        _.mp4Vars = {
          incrementor: 0,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="mp4"]:not(.video--init)',
        };
    
        _._loadMp4Videos = function (container) {
          if ($(_.mp4Vars.toProcessSelector, container).length) {
            // play those videos
            if (
              !(
                $(this).hasClass("video-container--background") &&
                $(window).outerWidth() < 768 && !($(this).find('div.video-container__video.video-container__video-show').length !== 0)
              )
            ) {
              $(_.mp4Vars.toProcessSelector, container)
                .addClass("video--init")
                .each(function () {
                  _.mp4Vars.incrementor++;
                  var $this = $(this);
                  var containerId = "theme-mp-video-" + _.mp4Vars.incrementor;
                  $(this).data("video-container-id", containerId);
                  var videoElement = $('<div class="video-container__video-element">')
                    .attr("id", containerId)
                    .appendTo($(".video-container__video", this));
                  var $video = $("<video playsinline>");
    
                  if ($(this).data("video-loop")) {
                    $video.attr("loop", "loop");
                  }
    
                  if ($(this).data("video-autoplay")) {
                    $video.attr({
                      autoplay: "autoplay",
                      muted: "muted",
                    });
                    $video.on("loadeddata", function () {
                      $(this).off("loadeddata");
                      this.muted = true; // required by Chrome - ignores attribute
    
                      this.play();
                    });
                  }
    
                  $video.on(
                    "playing",
                    function () {
                      $(this).addClass("video--play-started");
                    }.bind(this)
                  );
                  $video
                    .attr("src", $(this).data("video-url"))
                    .appendTo(videoElement);
                });
            } else {
              $(this).find("video-container__video").hide();
            }
          }
        };
    
        _._unloadMp4Videos = function (container) { }; // background video placement for iframes
    
        _._initBackgroundVideo = function ($container) {
          if ($container.hasClass("video-container--background")) {
            var assessBackgroundVideo = function assessBackgroundVideo() {
              var $container = this,
                cw = $container.width(),
                ch = $container.height(),
                cr = cw / ch,
                $frame = $(".video-container__video iframe", this),
                frameWidth = $frame.attr("width") || 640, // $frame.attr("width") has a constant value of 640 when resizing the screen, but initially is undefined
                frameHeight = $frame.attr("height") || 274, // $frame.attr("height") has a constant value of 274 when resizing the screen, but initially is undefined
                vr = frameWidth / frameHeight,
                $pan = $(".video-container__video", this),
                vCrop = 75; // pushes video outside container to hide controls

              if (cr > vr) {
                var vh = cw / vr + vCrop * 2;
                $pan.css({
                  marginTop: (ch - vh) / 2 - vCrop,
                  marginLeft: "",
                  height: vh + vCrop * 2,
                  width: "",
                });
              } else {
                var vw = cw * vr + vCrop * 2 * vr;
                $pan.css({
                  marginTop: -vCrop,
                  marginLeft: (cw - vw) / 2,
                  height: ch + vCrop * 2,
                  width: vw,
                });
              }
            };
    
            assessBackgroundVideo.bind($container)();
            $(window).on(
              "debouncedresize." + $container.data("video-container-id"),
              assessBackgroundVideo.bind($container)
            );
          }
        }; // Compatibility with Sections
    
        this.onSectionLoad = function (container) {
          // url only - infer type
          $(".video-container[data-video-url]:not([data-video-type])").each(
            (i, video) => {
              if(isMobile() && $(video).data("video-url-mobile")) {
                checkVideo($(video).data("video-url-mobile"), $(video));
              } else {
                checkVideo($(video).data("video-url"), $(video));
              }
            }
          );
    
          function checkVideo(url, video) {
    
            if (url.indexOf(".mp4") > -1) {
              $(video).attr("data-video-type", "mp4");
            }
    
            if (url.indexOf("vimeo.com") > -1) {
              $(video).attr("data-video-type", "vimeo");
              $(video).attr("data-video-id", url.split("?")[0].split("/").pop());
            }
    
            if (url.indexOf("youtu.be") > -1 || url.indexOf("youtube.com") > -1) {
              $(video).attr("data-video-type", "youtube");
    
              if (url.indexOf("v=") > -1) {
                $(video).attr(
                  "data-video-id",
                  url.split("v=").pop().split("&")[0]
                );
              } else {
                $(video).attr("data-video-id", url.split("?")[0].split("/").pop());
              }
            }
          }
    
          _._loadYoutubeVideos(container);
    
          _._loadVimeoVideos(container);
    
          _._loadMp4Videos(container);
    
          $(window).on("debouncedresize.video-manager-resize", function () {
            _._loadYoutubeVideos(container);

    
            _._loadVimeoVideos(container);
          }); // play button
    
          $(".video-container__play", container).on("click", function (evt) {
            evt.preventDefault();
            var $container = $(this).closest(".video-container"); // reveal
    
            $container.addClass("video-container--playing"); // play
    
            var id = $container.data("video-container-id");
    
            if (id.indexOf("theme-yt-video") === 0) {
              _.youtubeVars.videoData[id].player.playVideo();
            } else {
              _.vimeoVars.videoData[id].player.play();
            }
          }); // modal close button
    
          $(".video-container__stop", container).on("click", function (evt) {
            evt.preventDefault();
            var $container = $(this).closest(".video-container"); // hide
    
            $container.removeClass("video-container--playing"); // play
    
            var id = $container.data("video-container-id");
    
            if (id.indexOf("theme-yt-video") === 0) {
              _.youtubeVars.videoData[id].player.stopVideo();
            } else {
              _.vimeoVars.videoData[id].player.pause();
    
              _.vimeoVars.videoData[id].player.setCurrentTime(0);
            }
          });
        };
    
        this.onSectionUnload = function (container) {
          $(".video-container__play, .video-container__stop", container).off(
            "click"
          );
          $(window).off("." + $(".video-container").data("video-container-id"));
          $(window).off("debouncedresize.video-manager-resize");
    
          _._unloadYoutubeVideos(container);
    
          _._unloadVimeoVideos(container);
    
          _._unloadMp4Videos(container);
        };
    })(); // Youtube API callback
    
    window.onYouTubeIframeAPIReady = function () {
        theme.VideoManager.youtubeApiReady();
    }; // Register the section
    
    cc.sections.push({
        name: "video",
        section: theme.VideoManager,
    });

    $(function ($) {
        theme.Sections.init();
        
        theme.Sections.register("background-video", theme.VideoManager, {deferredLoadViewportExcess: 800, deferredLoad: false});
    }); //Register dynamically pulled in sections

    $(function ($) {
        if (cc.sections.length) {
            cc.sections.forEach(function (section) {
            try {
                theme.Sections.register(section.name, section.section);
            } catch (err) {
                console.error(
                "Unable to register section ".concat(section.name, "."),
                err
                );
            }
            });
        } else {
            console.warn("Barry: No common sections have been registered.");
        }
    });
})(jQuery);